import { forAllCallback } from "kwp-core/scripts/utils/helpers";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    const init = () => {
        forAllCallback(".content-block.content-block--featured-event", (el) => {
            const nextSection = el.nextElementSibling;
            const eventBanners = el.querySelectorAll(".event-banner");

            eventBanners.forEach((banner) => {
                const seeMoreButton = banner.querySelector(".see-more-button");
                const display = window
                    .getComputedStyle(banner)
                    .getPropertyValue("display");
                const isPortrait = parseFloat(banner.style.paddingBottom) > 100;

                if (display !== "none" && isPortrait && nextSection) {
                    seeMoreButton.style.display = "flex";
                    seeMoreButton.href = `#${nextSection.id}`;
                } else {
                    seeMoreButton.style.display = "none";
                }
            });

            const tween = gsap.from(el, {
                opacity: 0,
                duration: 0.5,
            });

            ScrollTrigger.create({
                trigger: el,
                start: "top bottom",
                end: "bottom top",
                animation: tween,
                once: true,
            });
        });
    };

    init();
};
